import { render, staticRenderFns } from "./WorkstationPage.vue?vue&type=template&id=37206e96&scoped=true"
import script from "./WorkstationPage.vue?vue&type=script&lang=js"
export * from "./WorkstationPage.vue?vue&type=script&lang=js"
import style0 from "./WorkstationPage.vue?vue&type=style&index=0&id=37206e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37206e96",
  null
  
)

export default component.exports